export default {
  en: {
    'team': 'team',
    'select': 'select',
    'unselect': 'unselect',
    'not_linedup': 'not linedup',
    'same_position': 'same position',
    'current': 'current',
    'lineup_automatically': 'lineup automatically',
    'select_formation': 'select formation',
    'reset': 'reset',
    'random': 'random',
    'bench': 'bench',
    'player_progressed': 'player progressed',
    'players': 'players',
    'lineup': 'lineup',
    'matches': 'matches',
    'best': 'best',
    'player': 'player',
    'total': 'total',
    'initial_reward': 'initial reward',
    'attributes': 'attributes',
    'data': 'data',
    'transfers': 'transfers',
    'no_transfers_yet': 'No transfers yet.',
    'no_offers_yet': 'No offers yet.',
    'transferred': 'transferred',
    'create_offer': 'create offer',
    'player_has_an_opened_offer_from_your_team': 'Player has an opened offer from your team.',
    'form': 'form',
    'base_form': 'base form',
    'next_form_change_at': 'next form change at',
    'energy': 'energy',
    'squad': 'squad',
    'x_matches_remaining_suspension': '{x} match(es)',
    'suspended': 'suspended',
    'formation': 'formation',
    'contracts': 'contracts',
    'value': 'value',
    'player_is_suspended': 'Player is suspended.',
    'contract': 'contract',
    'start_contract_negotiations': 'Start contract negotiations',
    'new_duration': 'new duration',
    'you_can_not_change_target_contract_duration_after_the_negotiation_started': 'You can not change target contract duration after the negotiation started.',
    'the_player_has_the_maximum_contract_duration': 'The player has the maximum contract duration!',
    'current_duration': 'current duration',
    'contract_details': 'contract details',
    'wage': 'wage',
    'current_contract': 'current contract',
    'negotiated_duration': 'negotiated duration',
    'team_target': 'team target',
    'player_target': 'player target',
    'the_player_will_end_career_at_the_end_of_his_contract': 'The player will end career at the end of his contract!',
    'player_has_been_transferred_this_season': 'Player has been transferred this season.',
    'player_has_ended_his_career_at': 'Player has ended his career at {date}.',
    'plan_career_end': 'plan career end',
    'end_of_career': 'end of career',
    'player_will_not_extend_the_contract_and_end_career_when_contract_expires': 'Player will not extend the contract and end career when contract expires.',
    'end_career_now': 'end career now',
    'remaining_contract': 'remaining contract',
    'at_your_club': 'at your club',
    'goals': 'goals',
    'seasons': 'seasons',
    'x_players_end_their_careers': '{x} players of your team end their careers today.',
    'players_contract_terminated_for_price': 'Contract of {player} terminated for fee of {price}.',
    'player_contract_termination': 'player contract termination',
    'without_club': 'without club',
    'show_sack_staff_member_action_screen': 'action screen: sack staff member',
    'players_leaving_your_club': 'players leaving your club',
    'player_careers_end': 'player careers end',
    'player_contracts_expire_contracts': 'player contracts expire contracts',
    'show_leaving_players': 'show leaving players',
    'expired_contracts': 'expired contracts',
    'continue': 'continue',
    'career_ends': 'career ends',
    'no_players': 'no players',
    'line_up_team': 'line up team',
    'you_have_less_then_x_amount_of_players_linedup': 'You have less then {x} of players linedup!',
    'lineup_need_to_have_at_laest_x_players': 'You need to have at laest {x} players on the field. If you continue, you will lose the game by default!',
    'suspended_players_linedup': 'You have suspended players on the field. You will not be able to start the match before you remove them!',
    'start_match': 'start match',
    'player_wages': 'player wages',
    'start_contract_negotiation': 'start contract negotiation',
    'show_ongoing_contract_negotiation': 'show ongoing contract negotiation',
    'player_will_end_his_career': 'player will end his career',
    'nationality': 'nationality',
    '': '',
  }
};